import React from 'react';
import classnames from 'classnames';
import SubfoldersIcon from '@wix/da-ds/pkg/Icons/24x24/Subfolders';
import FolderCoverInfo from '../../../FolderCoverInfo';
import { normalizePremiumFolderData } from '../../../utils/normalizePremiumFolderData';
import GallectionCoverDumbo from '../../../GallectionCoverDumbo';
import folderCardStyles from '../../FolderCard.scss';
const FolderCardContent = ({ className, folder, folder: { subfolders, hasSubfolders: hasSubfoldersFromFolder = !!(subfolders === null || subfolders === void 0 ? void 0 : subfolders.length), type }, totalDeviationCount, hasSubfolders: hasSubfoldersOverride, isCurrentUserOwner, width, height })=>{
    var _folder_thumb;
    const hasSubfolders = hasSubfoldersOverride !== null && hasSubfoldersOverride !== void 0 ? hasSubfoldersOverride : hasSubfoldersFromFolder;
    if (!width || !height) {
        return null;
    }
    const isPremiumFolder = normalizePremiumFolderData(folder.premiumFolderData).isPremium;
    const isFolderThumbPublished = folder.thumb && folder.thumb.isPublished;
    const showBlurredThumbInfoToOwner = isCurrentUserOwner && isPremiumFolder && isFolderThumbPublished && ((_folder_thumb = folder.thumb) === null || _folder_thumb === void 0 ? void 0 : _folder_thumb.premiumFolderData);
    return /*#__PURE__*/ React.createElement("div", {
        className: className
    }, hasSubfolders && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: folderCardStyles['subfolders-icon-underlay']
    }), /*#__PURE__*/ React.createElement("div", {
        className: folderCardStyles['top-right-icons']
    }, hasSubfolders && /*#__PURE__*/ React.createElement(SubfoldersIcon, {
        className: classnames(folderCardStyles['subfolders-icon'])
    }))), /*#__PURE__*/ React.createElement(GallectionCoverDumbo, {
        width: width,
        height: height,
        gallection: folder
    }), showBlurredThumbInfoToOwner && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: folderCardStyles['info-icon-underlay']
    }), /*#__PURE__*/ React.createElement("div", {
        className: folderCardStyles['top-right-icons']
    }, /*#__PURE__*/ React.createElement(FolderCoverInfo, null))));
};
export default FolderCardContent;
